import './About.scss';
import faceMassage from '../assets/face-massage-2.jpg';
import { Button, Theme } from '../components/button/Button';
import { isDesktop } from 'react-device-detect';

export function About() {
  return (
    <section id="about" className="about">
      <div className="about-content lato-thin">
        <h1 className="lato-thin">
          L&apos;EXPERTISE AU SERVICE DE VOTRE BIEN-ÊTRE
        </h1>
        <p>
          Bienvenue dans mon univers du soin sans botox ni injection, où la
          beauté se révèle en douceur grâce à des techniques manuelles
          naturelles et profondément efficaces. Les rides s&apos;estompent,
          l&apos;ovale du visage se redessine, l&apos;éclat de la peau renaît…
          naturellement, tout simplement.
        </p>
        <p>
          Je vous invite à découvrir de véritables alliées naturelles anti-âge,
          puissantes et respectueuses, alliant précision du geste, efficacité
          durable et douceur du toucher.
        </p>
        <p>
          Chaque soin repose sur une méthode non-invasive, conçue pour prévenir
          et atténuer les signes du temps, tout en vous offrant un véritable
          moment de bien-être, d&apos;harmonie et de reconnexion à soi.
        </p>
        <p>
          Parce que chaque visage est unique, je vous accompagne avec attention
          et bienveillance, avant, pendant et après chaque séance, afin de vous
          proposer la technique la plus adaptée à vos besoins et à
          l&apos;histoire de votre peau.
        </p>
        <a href="#prestations">
          <Button label="Découvrir les prestations" theme={Theme.DARK} />
        </a>
      </div>

      {isDesktop && (
        <img src={faceMassage} className="about-image" alt="face massage" />
      )}
    </section>
  );
}
